// extracted by mini-css-extract-plugin
export default {"lets_connect":"profile_lets_connect__UKXE5","box":"profile_box__NQber","heading":"profile_heading__QguVH"};